// extracted by mini-css-extract-plugin
export default {"heading":"PA-z","signin":"QA-z","signupBtn":"RA-z","disabled":"SA-z"};